import { useEffect, RefObject } from 'react';
import DataTypeUtils from '@gp/utils/DataTypeUtils';
import type { EChartsOption } from 'echarts/types/dist/shared';

/**
 * echart配置项变化时,更新echart UI
 */
export default function useChartRefreshWhenOptionsChange<
  T extends EChartsOption,
>(chartInstance: RefObject<IEChartInstanceRefObject>, option: T) {
  // echart配置项变化时,更新echart UI
  useEffect(() => {
    if (
      chartInstance?.current?.instance &&
      DataTypeUtils.isFunction(chartInstance?.current?.instance?.setOption)
    ) {
      chartInstance?.current?.instance?.setOption(option, {
        /**
         * 是否不跟之前设置的 option 进行合并。默认为 false
         * 如果为 false，即表示合并
         * 如果为 true，表示所有组件都会被删除，然后根据新 option 创建所有新组件
         */
        notMerge: false,
        /**
         * 在设置完 option 后是否不立即更新图表，默认为 false
         * 如果为 false，即同步立即更新
         * 如果为 true，则会在下一个 animation frame 中，才更新图表
         */
        lazyUpdate: false,
        // 阻止调用 setOption 时抛出事件，默认为 false，即抛出事件。
        silent: false,
      });
    }
  }, [option]);
}
